import React from "react"
import clsx from "clsx"

import classes from "./PvPaperWidths.module.scss"

const paperWidths = [72, 64, 54, 48]

const PvPaperWidths = (props) => {
  const {
    selectedPaperWidth,
    setSelectedPaperWidth
  } = props

  return (
    <div className={classes["row"]}>
      {paperWidths.map(paperWidth =>
        <button
          key={paperWidth}
          onClick={() => setSelectedPaperWidth(paperWidth)}
          className={clsx(
            classes["button"],
            paperWidth === selectedPaperWidth && classes["active"]
          )}
        >
          {paperWidth} mm
        </button>
      )
      }
    </div>
  )
}

export default PvPaperWidths

